import { ClienteService } from '../services/cliente.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
var ClientesLayoutComponent = /** @class */ (function () {
    function ClientesLayoutComponent(clienteService, router, authService) {
        this.clienteService = clienteService;
        this.router = router;
        this.authService = authService;
        this.clientes = [];
        this.multiRol = false;
        this.kairos = false;
        this.kairos = environment.kairos;
    }
    ClientesLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.username = this.authService.username;
        this.multiRol = this.authService.roles.indexOf("intranet") > -1 && this.authService.roles.indexOf("usuario") > -1;
        if (!this.multiRol) {
            this.toggleClass(document.querySelector('body'), 'sidebar-off-canvas');
        }
        if (this.router.url === '/clientes') {
            this.clienteService.listado(0, 10, "").subscribe(function (result) {
                if (result.clientes.length > 0) {
                    _this.removeClass(document.querySelector('body'), 'sidebar-off-canvas');
                    _this.clienteService.clientesUsuario = result.clientes;
                    _this.clientes = result.clientes;
                    _this.clienteService.setCliente(_this.clientes[0]);
                    _this.router.navigate(['clientes/ctacte/aplicada']);
                }
                else if (_this.authService.roles.indexOf("intranet") > -1) {
                    _this.router.navigate(['intranet/kairos']);
                }
                else {
                    _this.logout();
                }
            });
        }
    };
    ClientesLayoutComponent.prototype.logout = function () {
        this.authService.logout();
        this.router.navigate(['login']);
    };
    ClientesLayoutComponent.prototype.toggleClass = function (elem, elementClassName) {
        var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
        if (!this.hasClass(elem, elementClassName)) {
            elem.className += ' ' + elementClassName;
        }
    };
    ClientesLayoutComponent.prototype.removeClass = function (elem, elementClassName) {
        elem.className += elem.className.replace(elementClassName, '');
    };
    ClientesLayoutComponent.prototype.hasClass = function (target, elementClassName) {
        return new RegExp('(\\s|^)' + elementClassName + '(\\s|$)').test(target.className);
    };
    ClientesLayoutComponent.prototype.clienteChange = function (id) {
        var cliente = this.clientes.find(function (c) {
            return c.id === id;
        });
        this.clienteService.setCliente(cliente);
    };
    ClientesLayoutComponent.ctorParameters = function () { return [{ type: ClienteService }, { type: Router }, { type: AuthService }]; };
    return ClientesLayoutComponent;
}());
export { ClientesLayoutComponent };
//# sourceMappingURL=clientes-layout.component.js.map


// WEBPACK FOOTER //
// clientes-layout.component.js